module.exports = __webpack_public_path__ + "img/es.751f8983.jpg";